if ($('header#header').length) {
    document.addEventListener('ShoptetDOMCartContentLoaded', function () {
        checkCartState();
        checkHeight();
    });
    document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function () {
        checkCartState();
        checkHeight();
    });
    $(document).ready(function(){
        checkCartState();
    })
    document.addEventListener('ShoptetCartUpdated', function () {
        checkCartState();
        checkHeight();
    });
    

    document.addEventListener('dkLabProductComparerHeaderChanged', function() {
        $('.responsive-tools').append($('.navigation-buttons #dkLabComparerHeaderWrappper'));
    });
    $('body.mobile .navigation-buttons a[data-target="cart"]').removeClass('toggle-window');
    if (!$('#cart-widget .emptyCart').length) {
        $('#cart-widget').append($('#footer .emptyCart'));
    }
    if (!$('#cart-widget .cartCategories').length) {
        $('#cart-widget').append($('#footer .cartCategories'));
    }
$(function () {
    const $cartHoverArea = $('body:not(.mobile) a[data-target="cart"]:not(.full)');

    $cartHoverArea.off('mouseenter.customCartPopup').on('mouseenter.customCartPopup', function () {
        shoptet.popups.showPopupWindow("cart", true);
    });
});
    function freeShippingBar() {
        var cartInfo = dataLayer[0].shoptet.cartInfo;
        var freeShippingFrom = cartInfo.freeShippingFrom;
        var priceLeft = cartInfo.leftToFreeShipping.priceLeft;

        if (!$('.cart-widget-button .cart-free-shipping').length) {
            $('#cart-widget .cart-widget-button').prepend($('#cart-widget .cart-widget-inner .cart-free-shipping'));
        }
        if ((!$('.cart-widget-button .cart-free-shipping .bar').length)) {
            $('.cart-widget-button .cart-free-shipping').append('<div class="bar"><span class="inner"></span></div>');
        }

        if (priceLeft <= 0) {
            $('.cart-widget-button .cart-free-shipping').addClass('freeNow');
            if (!$('.cart-widget-button .cart-free-shipping .free').length) {
                $('.cart-widget-button .cart-free-shipping').append('<strong class="free">Dopravu máte zdarma!</strong>');

            }
            return;
        }
        var progress = 0;
        $('.cart-widget-button .cart-free-shipping').removeClass('freeNow');
        var currentAmount = freeShippingFrom - priceLeft;
        progress = (currentAmount / freeShippingFrom) * 100;
        progress = Math.max(0, Math.min(100, progress));
        $('.cart-widget-button .cart-free-shipping div strong:first').text(priceLeft + ' Kč');
        $('.cart-widget-button .cart-free-shipping .bar .inner').css('width', progress + '%');
    }
    

   // checkCartState();
    document.addEventListener('ShoptetDOMCartContentLoaded', function () {
      //  checkCartState();
        freeShippingBar();

    });
    document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function () {
      //  checkCartState();
        freeShippingBar();
    });

    $('.header-top').prepend('<a href="#" class="toggle-window" data-target="navigation" aria-label="Menu" data-testid="hamburgerMenu">' + translation('menu') + '</a>');
    $('#formSearchForm input[type="search"]').attr('placeholder', translation('searchPlaceholder'));
    $('.responsive-tools').append($('footer#footer .heurekaHeader')).append($('.top-navigation-bar .top-navigation-contacts .project-phone').clone())
    $('.header-top .navigation-buttons').prepend($('.responsive-tools'));
$(document).on('click', 'body.mobile .navigation-buttons a[data-target="cart"]', function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var href = $(this).attr('href');

    if (href) {
        window.location.assign(href);
    }

    return false;
});

    $('.navigationActions').append($('.top-navigation-bar-menu').html(), '<li class="customNumber"><span class="link"></span></li>');

   // $('.navigationActions').append($('.top-navigation-bar-menu').html(), '<li class="customNumber"><span class="link"></span></li>');

    $('.navigationActions .customNumber .link').append($('.top-navigation-bar .top-navigation-contacts .project-phone').clone())
    $('nav#navigation img').each(function () {
        $(this).attr('src', $(this).attr('data-src'))
    });
    $('html').on('click', 'nav#navigation .navigation-in > ul.menu-level-1 > li.ext.exp > a .submenu-arrow', function (e) {
        if ($('body').hasClass('submenu-visible')) {
            e.preventDefault();
            $('body').removeClass('submenu-visible');
        }
    }
    );

    $(function () {
        updateSupportStatus();


        $('ul.menu-level-2 > li').each(function () {

            var $level2Item = $(this);
            var $level3 = $level2Item.children('div').find('ul.menu-level-3').first();

            if (!$level3.length) return;

            var $items = $level3.children('li');
            var itemsCount = $items.length;

            // hlavní odkaz kategorie
            var $parentLink = $level2Item.children('div').children('a').first();

            // přidáme toggle span jen jednou
            if (!$parentLink.find('.menuToggle').length) {
                $parentLink.append('<span class="menuToggle" aria-hidden="true"></span>');
            }

            // uložíme počet položek
            $level3
                .attr('data-items-count', itemsCount)
                .data('itemsCount', itemsCount);

            if (itemsCount > MaxMenuItems) {
                $level3.attr('data-has-more', 'true');

                // skryjeme položky od 6. dál
                $items.each(function (index) {
                    if (index >= MaxMenuItems) {
                        $(this).hide();
                    }
                });

                // odkaz na hlavní kategorii
                var parentHref =
                    $level2Item.children('div').children('a').attr('href') ||
                    $level2Item.children('a').attr('href') ||
                    '#';

                // vložení "Zobrazit další"
                var $moreItem = $('<li/>', {
                    class: 'menuItemMore'
                }).append(
                    $('<a/>', {
                        href: parentHref,
                        class: 'menuMoreLink showMore',
                        text: translation('zobrazitDalsiVMenu'),
                        role: 'menuitem'
                    })
                );

                $level3.append($moreItem);
            }
        });
        $('#header ul > li.ext').each(function () {
            var $mainItem = $(this);
            var $mainLink = $mainItem.children('a[href]');
            var href = $mainLink.attr('href');
            if (!href) return;
            var slug = href.replace(/\//g, '');
            var $menuLevel2 = $mainItem.children('ul.menu-level-2');
            if (!$menuLevel2.length) return;
            var $footerBanner = $('#footer').find('[data-menuUrl="' + slug + '"]');
            if (!$footerBanner.length) return;
            var $bannerClone = $footerBanner.html();
            $menuLevel2.append(
                $('<li/>', {
                    class: 'menuItemBanner'
                }).html($bannerClone)
            );

        });

      $(document).on('click', '.menuToggle', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $level2Item = $(this).closest('li.has-third-level');
    var $level2 = $level2Item.parent('ul.menu-level-2');
    var $level3 = $level2Item.children('div').children('ul.menu-level-3').first();
    var $parentLink = $level2Item.children('div').children('a').first();

    if (!$level3.length || !$parentLink.length) return;

    var title = $.trim($parentLink.find('span').first().text());
    var href = $parentLink.attr('href') || '#';

    $level2
        .children('li.has-third-level')
        .not($level2Item)
        .removeClass('isOpen')
        .children('div')
        .children('ul.menu-level-3')
        .hide();

    $level2.addClass('menuLevel3Opened');
    $level2.closest('li.ext').addClass('menuLevel3ParentOpened');

    $level2
        .children('li')
        .not($level2Item)
        .hide();

    $level2Item
        .addClass('isOpen')
        .show();

    if (!$level2Item.children('.menuLevel3Header').length) {
        var $header = $('<div/>', {
            class: 'menuLevel3Header'
        });

        var $back = $('<button/>', {
            type: 'button',
            class: 'menuLevel3Back',
            'aria-label': 'Zpět'
        });

        var $title = $('<strong/>', {
            class: 'menuLevel3Title',
            text: title
        });

        var $showAll = $('<a/>', {
            href: href,
            class: 'menuLevel3ShowAll',
            text: 'Zobrazit vše'
        });

        $header.append($back, $title, $showAll);
        $level2Item.prepend($header);
    } else {
        $level2Item.find('.menuLevel3Title').text(title);
        $level2Item.find('.menuLevel3ShowAll').attr('href', href);
    }

    $level3.show();
});
$(document).on('click', '.menuLevel3Back', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $level2Item = $(this).closest('li.has-third-level');
    var $level2 = $level2Item.parent('ul.menu-level-2');
    var $level3 = $level2Item.children('div').children('ul.menu-level-3').first();

    $level2.removeClass('menuLevel3Opened');
    $level2.closest('li.ext').removeClass('menuLevel3ParentOpened');

    $level2Item
        .removeClass('isOpen')
        .children('.menuLevel3Header')
        .remove();

    $level3.hide();

    $level2.children('li').show();
});

    });

   /* $(document).on('click', '.menuMoreLink', function (e) {
        e.preventDefault();

        var $link = $(this);
        var $menuLevel3 = $link.closest('ul.menu-level-3');

        if (!$menuLevel3.length) return;

        var isExpanded = $menuLevel3.hasClass('is-expanded');

        if (!isExpanded) {
            // 🔽 ZOBRAZIT DALŠÍ
            $menuLevel3.children('li').show();
            $menuLevel3.addClass('is-expanded');
            $link.text(translation('zobrazitMene') || 'Zobrazit méně');
            $link.toggleClass('showMore')
        } else {
            // 🔼 ZOBRAZIT MÉNĚ
            var maxItems = typeof MaxMenuItems !== 'undefined' ? MaxMenuItems : 5;

            $menuLevel3.children('li').each(function (index) {
                if (index >= maxItems && !$(this).hasClass('menuItemMore')) {
                    $(this).hide();
                }
            });

            $menuLevel3.removeClass('is-expanded');
            $link.text(translation('zobrazitDalsiVMenu') || 'Zobrazit další');
            $link.toggleClass('showMore')
        }
    });*/

}


if ($('body.mobile')) {
    $(document).on('click', '.search', function () {
        $('html, body').stop().animate({
            scrollTop: 0
        }, 50);
    });
}

